<!--
 * @Description: 
 * @version: 
 * @Author: yfw
 * @Date: 2023-02-07 15:05:12
 * @LastEditors: yfw
 * @LastEditTime: 2023-03-16 10:13:02
-->
<template>
    <div class="container">
        <div class="bgoverlay">
            <div class="bg" :style="{ 'background-image': `url(${require('@/assets/images/newsbg.jpg')})` }"></div>
        </div>
        <div class="inner-pannel">
            <div class="pannel-content" style="padding-right:0;border-bottom:0;">
                <div class="pannel-content-box" style="padding:0;border-right:0;">
                    <div class="content-page">
                        <div class="ani animate__animated animate__fadeInUp">
                            <div style="height:43px"></div>
                            <el-row>
                                <!-- <el-col :span="3">
                        <el-select v-model="value" @change="selectChange">
                            <el-option
                                v-for="item in $t('groupNews.options')"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col> -->
                                <el-col :span="24">
                                    <div style="padding: 0 50px 0 50px">
                                        <el-input v-model="keyword" prefix-icon="el-icon-search"
                                            :placeholder="$i18n.locale == 'zh' ? '关键词搜索' : 'search'"
                                            @input="search"></el-input>
                                    </div>
                                </el-col>
                            </el-row>
                            <div style="height:43px"></div>
                            <div class="flex">
                                <div class="time-line-box">
                                    <div class="ball"></div>
                                </div>
                                <div v-for="item in yearList" style="width: calc(15% + 40px);">
                                    <div :class="value == item ? 'time-text-box1 year-active' : 'time-text-box1'"
                                        @click="changeYear(item)">
                                        {{ item }}
                                        <div :class="value == item ? 'ball-active time-ball' : 'time-ball'"></div>
                                    </div>
                                    <div class="time-line-box1"></div>
                                </div>
                                <div class="time-line-box" style="width: 100%;">
                                    <div class="end-ball"></div>
                                </div>
                            </div>

                            <!-- <div style="height:43px"></div>
                            <div class="flex">
                                <div class="time-line-box">
                                    <div class="ball"></div>
                                </div>
                                <div :class="value == '2022' ? 'time-text-box year-active' : 'time-text-box'"
                                    @click="changeYear('2022')">
                                    2022
                                    <div :class="value == '2022' ? 'ball-active time-ball' : 'time-ball'"></div>
                                </div>
                                <div class="time-line-box"></div>
                                
                                <div :class="value == '2021' ? 'time-text-box year-active' : 'time-text-box'"
                                    @click="changeYear('2021')">
                                    2021
                                    <div :class="value == '2021' ? 'ball-active time-ball' : 'time-ball'"></div>
                                </div>
                                <div class="time-line-box"></div>
                                <div :class="value == '2020' ? 'time-text-box year-active' : 'time-text-box'"
                                    @click="changeYear('2020')">
                                    2020
                                    <div :class="value == '2020' ? 'ball-active time-ball' : 'time-ball'"></div>
                                </div>
                                <div class="time-line-box" style="width: 100%;">
                                    <div class="end-ball"></div>
                                </div>
                            </div> -->

                            <div style="height:64px"></div>

                            <div v-for="(item, index) in yearNewsList" :key="index" class="main-box">
                                <div>
                                    <div v-if="$i18n.locale == 'zh'" class="title">{{ item.releaseDate }} {{ item.source }}</div>
                                    <div v-else class="title">{{ item.releaseDate }} {{ item.sourceEn }}</div>
                                    <div v-if="$i18n.locale == 'zh'" class="content zh-font" @click="openDetail(item.url)">{{ item.title }}</div>
                                    <div v-else class="content en-font" @click="openDetail(item.urlEn)"> {{ item.titleEn }}</div>
                                </div>
                                <div style="height:20px"></div>
                            </div>

                            <!-- <div v-for="(item, index) in dataList" :key="index" class="main-box">
                                <div>
                                    <div class="title">{{ item.title }}</div>
                                    <div :class="$i18n.locale == 'zh' ? 'content zh-font' : 'content en-font'"
                                        @click="openDetail(item.href)">{{ item.content1 }}</div>
                                </div>
                                <div style="height:20px"></div>
                            </div> -->
                            
                            <div style="height:60px"></div>
                            <div class="pagination">
                                <el-pagination :current-page="pageno" :page-size="pagesize" small layout="prev, pager, next" :total="total" @current-change="handleCurrentChange">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import groupNewsService from './groupNews-service'
import { request, get } from '../../utils/axios';

export default ({
    data() {
        return {
            value: '2022',
            keyword: "",
            dataList: [],
            orgData: [],

            yearList: [], //新闻年份列表
            yearNewsList: [],//年份新闻列表
            total: 0,
            pageno: 1,
            pagesize: 10
        }
    },
    created() {
        this.getNewsYear();
        return;

        if (this.value === '2021') {
            this.dataList = [this.$t('groupNews.contents[0]'), this.$t('groupNews.contents[1]')]
            this.orgData = [this.$t('groupNews.contents[0]'), this.$t('groupNews.contents[1]')]
        } else if (this.value === '2020') {
            this.dataList = [this.$t('groupNews.contents[2]'), this.$t('groupNews.contents[3]'), this.$t('groupNews.contents[4]')]
            this.orgData = [this.$t('groupNews.contents[2]'), this.$t('groupNews.contents[3]'), this.$t('groupNews.contents[4]')]
        } else if (this.value === '2022') {
            this.dataList = [this.$t('groupNews.contents[5]'), this.$t('groupNews.contents[6]'), this.$t('groupNews.contents[7]'), this.$t('groupNews.contents[8]'), this.$t('groupNews.contents[9]'), this.$t('groupNews.contents[10]'), this.$t('groupNews.contents[11]')]
            this.orgData = [this.$t('groupNews.contents[5]'), this.$t('groupNews.contents[6]'), this.$t('groupNews.contents[7]'), this.$t('groupNews.contents[8]'), this.$t('groupNews.contents[9]'), this.$t('groupNews.contents[10]'), this.$t('groupNews.contents[11]')]
        }
    },
    methods: {
        openDetail(href) {
            window.open(href, '_blank')
        },
        changeYear(year) {
            this.value = year;
            this.pageno = 1;
            // this.selectChange();
            this.getNewsList();
        },
        selectChange() {
            this.keyword = ''
            if (this.value === '2021') {
                this.dataList = [this.$t('groupNews.contents[0]'), this.$t('groupNews.contents[1]')]
            } else if (this.value === '2020') {
                this.dataList = [this.$t('groupNews.contents[2]'), this.$t('groupNews.contents[3]'), this.$t('groupNews.contents[4]')]
                this.orgData = [this.$t('groupNews.contents[2]'), this.$t('groupNews.contents[3]'), this.$t('groupNews.contents[4]')]
            } else if (this.value === '2022') {
                this.dataList = [this.$t('groupNews.contents[5]'), this.$t('groupNews.contents[6]'), this.$t('groupNews.contents[7]'), this.$t('groupNews.contents[8]'), this.$t('groupNews.contents[9]'), this.$t('groupNews.contents[10]'), this.$t('groupNews.contents[11]')]
                this.orgData = [this.$t('groupNews.contents[5]'), this.$t('groupNews.contents[6]'), this.$t('groupNews.contents[7]'), this.$t('groupNews.contents[8]'), this.$t('groupNews.contents[9]'), this.$t('groupNews.contents[10]'), this.$t('groupNews.contents[11]')]
            }
        },
        search() {
            this.pageno = 1;
            this.getNewsList();
            return;
            if (this.keyword == '') {
                this.selectChange()
                return
            }
            var _this = this
            var newData = []
            clearTimeout(this.timer)
            this.timer = setTimeout(function () {
                console.log(_this.keyword)
                _this.orgData.forEach(ele => {
                    if (ele.title.indexOf(_this.keyword) != -1 || ele.content1.indexOf(_this.keyword) != -1) {
                        newData.push(ele)
                    }
                })
                _this.dataList = newData
            }, 500)
        },

        // 获取新闻年份列表
        getNewsYear() {
            let params = {
                classifyid: 1
            }
            let url = "/newsapi/api/news/getyear/list";
            get(url, params).then((res) => {
                if (res.data.code == 200) {
                    let yearList = res.data.data;
                    this.yearList = yearList;
                    if (yearList.length > 0) {
                        let leastYear = yearList[0];
                        this.value = leastYear;
                        this.getNewsList(leastYear);
                    }
                }
            })
        },

        // 获取新闻列表
        getNewsList() {
            let params = {
                year: this.value,
                classifyid: 1,
                pageno: this.pageno,
                pagesize: this.pagesize
            }
            if (this.keyword != "") {
                params.title = this.keyword;
            }
            let url = "/newsapi/api/news/gethome/list";
            get(url, params).then((res) => {
                if (res.data.code == 200) {
                    let yearNewsList = res.data.data ? res.data.data : [] ;
                    this.yearNewsList = yearNewsList;
                    this.total = res.data.count ? res.data.count : 0;
                }
            })
        },

        handleCurrentChange(val) {
            this.pageno = val;
            this.getNewsList();
        }
    }
})
</script>

<style scoped>
/deep/ .el-input__inner {
    background: transparent;
    border-radius: 0;
    color: #ffffff;
    border-color: #707070;
}

/deep/ .el-select-dropdown__item .selected {
    color: #ED6D00;
}

.title {
    font-size: 18px;
    color: #ED6D00;
}

.inner-pannel::after {
    display: none;
}

.pannel-content {
    border-bottom: 0;
    padding-right: 0;
}

.pannel-content::before {
    display: none;
}

.pannel-content-box {
    border-right: 0;
    padding: 0px;
    padding-bottom: 50px;
}

.pannel-content-box::before {
    display: none;
}

.main-box {
    padding: 0 50px 0 50px;
}

.inner-pannel {
    min-height: 100%;
    padding-bottom: 54px;
    position: static;
    /* position: relative; */
    /* position: absolute; */
    width: 100%;
}

.pagination {
    text-align: center;
}

/deep/ .el-pagination button:disabled {
    background: transparent;
}

/deep/ .el-pager li {
    background: transparent;
    color: #FFFFFF;
}

/deep/ .el-pagination--small .btn-next {
  color: #ED6D00;
  background: transparent;
}

/deep/ .el-pagination--small .btn-prev {
  color: #ED6D00;
  background: transparent;
}

/deep/ .el-pagination .btn-prev {
    background-color: unset;
    /* color: #FFFFFF; */
}

/deep/ .el-pagination .btn-next {
    background-color: unset;
    /* color: #FFFFFF; */
}

/deep/ .el-pager li.active {
    color: #ED6D00;
}

.flex {
    display: flex;
}

.time-line-box {
    width: 15%;
    border-bottom: 1px solid #ffffff;
    position: relative;
}

.time-text-box {
    height: 50px;
    color: #707070;
    position: relative;
    text-align: center;
    border-bottom: 1px solid #ffffff;
    cursor: pointer;
}

.time-line-box2 {
    width: 100%;
    border-bottom: 1px solid #ffffff;
    position: relative;
}

.time-text-box1 {
    height: 50px;
    color: #707070;
    position: relative;
    /* text-align: center; */
    border-bottom: 1px solid #ffffff;
    cursor: pointer;
}

.year-active {
    color: #ED6D00;
}

.content {
    cursor: pointer
}

.ball {
    position: absolute;
    width: 30px;
    height: 30px;
    left: -15px;
    bottom: -15px;
    background: #ED6D00;
    border-radius: 50%;
}

.end-ball {
    position: absolute;
    width: 30px;
    height: 30px;
    right: -15px;
    bottom: -15px;
    background: #ED6D00;
    border-radius: 50%;
}

.time-ball {
    position: absolute;
    width: 30px;
    height: 30px;
    left: 5px;
    bottom: -15px;
    background: #707070;
    border-radius: 50%;
}

.ball-active {
    background: #ED6D00;
}
</style>



// WEBPACK FOOTER //
// src/components/groupNews/groupNews.vue